import { useState } from 'react';

function useLocalStorage<V>(key: string, initialValue?: V, prefix = 'wecasa'): [V, (value: V) => void] {
  const prefixedKey = `${prefix}-${key}`;
  const [value, setValue] = useState<V>(() => {
    const storedValue = localStorage.getItem(prefixedKey);
    try {
      return storedValue ? JSON.parse(storedValue) : initialValue;
    } catch (e) {
      localStorage.removeItem(prefixedKey);
      return undefined;
    }
  });

  const handleSetValue = (newValue: V) => {
    localStorage.setItem(prefixedKey, JSON.stringify(newValue));
    setValue(newValue);
  };

  return [value, handleSetValue];
}

export default useLocalStorage;
